import { Header, Layout, Logo } from '@kanda-libs/ks-design-library';

interface UnsubLayoutMobileProps {
  children: React.ReactNode;
  footer: React.ReactNode;
}

const UnsubLayoutMobile: React.FunctionComponent<UnsubLayoutMobileProps> =
  function ({ children, footer }) {
    return (
      <Layout
        header={
          <Header.Base lines hideNumber>
            <div className="flex flex-row w-full justify-between">
              <Logo height={20} className="my-auto" />
            </div>
          </Header.Base>
        }
        footer={footer ? <>{footer}</> : undefined}
        stickyFooter
        stickyHeader
      >
        <>{children}</>
      </Layout>
    );
  };

export default UnsubLayoutMobile;
